/**
 * Shared layout tokens for standalone pages (VoxPont2, etc.).
 * Use for congruent rounded containers and section cards; no color changes.
 *
 * NOTE: Values are MUI `borderRadius` multipliers (theme.shape.borderRadius units),
 * kept local so standalone pages do not depend on the experimental shared-utils tokens.
 */

export const RADIUS_SMALL = 1;
export const RADIUS_MEDIUM = 2;
export const RADIUS_LARGE = 3;

export const CONTENT_PADDING = 2;

/** Spread onto MUI Paper (and set elevation={0}) for section cards. */
export const contentCardSx = {
  borderRadius: RADIUS_MEDIUM,
  border: '1px solid',
  borderColor: 'divider',
};
